import React, { useState } from 'react';

import { ReactComponent as IconLoading } from '../../assets/icons/spinner.svg';
import { ReactComponent as IconEdit } from '../../assets/icons/edit.svg';
import { ReactComponent as IconDetails } from '../../assets/icons/info.svg';
import { ReactComponent as IconDel } from '../../assets/icons/trash.svg';
import { useNavigate } from 'react-router-dom';
import { showError } from '../../utils';
import { deleteFaq } from '../../api';

// Righe di chiamate raggruppate con espansione dettagli
const FaqListRow = ({ contact, setRawList }) => {
    const { id, numtel, titolo, data_creazione} = contact;
   
    const [isLoadingDel, setIsLoadingDel] = useState(false);
    const navigate = useNavigate();
    
    const handleRemoveFaq = async () => {
        setIsLoadingDel(true);
        try{
            await deleteFaq(id);
            setRawList(prev => prev.filter(item => item.id !== id));
        }catch(err){
            showError([err.message]);
        }finally{
            setIsLoadingDel(false);
        }
    }
    //qui solo prima lettera maiuscola, per il titolo
    const titoloLower = titolo[0].toUpperCase() + titolo.toLowerCase().slice(1);
   
    return (
        <div className={`vista-row`} data-numero={numtel}>
            <div className="vista-row-info">
                <div className="sx">
                    <div className="item">
                        <span className="title text-trunc-ellipsis">{titoloLower}</span>
                        <div className='item-content'>
                            <span className="subtitle text-trunc-ellipsis">
                                {data_creazione.split(' ')[0].replace(/(\d{4})(\d{2})(\d{2})/, '$3/$2/$1')}<br/>
                                {data_creazione.split(' ')[1].replace(/:\d{2}$/, '')}
                            </span>
                            <div className="actions">
                                <button className="icon-button"><IconEdit onClick={() => navigate('/faq', { state: { id } })} /></button>
                                <button className="icon-button"><IconDetails onClick={() => navigate('/faq',{ state: { id, op: 'show' } } )} /></button>
                                <button className="icon-button" onClick={handleRemoveFaq} disabled={isLoadingDel}>{isLoadingDel ? <IconLoading className="icon icon-loading"/> : <IconDel/>}</button>
                            </div>
                        </div>
                    </div>
                </div>
               
            </div>
           
        </div>
    );
}

export default FaqListRow;